import "@/App.css";

function App() {
  return (
    <div className="bg-black min-h-screen flex flex-col font-sans">
      {/* Header */}
      <header className="p-6 md:p-8">
        <span className="text-xs text-gray-500 uppercase tracking-widest font-medium">
          FORTIOL LABS
        </span>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center px-6 md:px-8">
        <div className="max-w-4xl w-full">
          {/* Main Headline */}
          <h1 
            className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight"
            data-testid="main-headline"
          >
            Deterministic Profit Infrastructure for Scale.
          </h1>

          {/* Sub-headline */}
          <p 
            className="mt-8 text-xl md:text-2xl text-gray-400 leading-relaxed"
            data-testid="sub-headline"
          >
            Fortiol Labs builds proprietary data intelligence layers that audit, detect, and neutralize capital bleed in high-volume D2C and PLG SaaS ad pipelines.
          </p>

          {/* Status Box */}
          <div 
            className="mt-12 border border-gray-800 bg-gray-950 p-8"
            data-testid="status-box"
          >
            <p className="text-white text-lg">
              <span className="font-bold">System Status: Closed Beta.</span>
              <span className="text-gray-400 ml-1">
                We are currently operating by invitation only for brands exceeding ₹50L/month in revenue. To request a Level 1 Waste Audit, contact the founding team.
              </span>
            </p>
          </div>

          {/* Contact Footer */}
          <a 
            href="mailto:audit@fortiollabs.com" 
            className="text-white font-mono hover:underline mt-8 block"
            data-testid="contact-email"
          >
            audit@fortiollabs.com
          </a>
        </div>
      </main>
    </div>
  );
}

export default App;
